import {useTypedSelector} from "../../../hooks/useTypedSelector";
import './Header.css';

function Header() {

    const {cpuData} = useTypedSelector(state => state.game);
    const {user} = useTypedSelector(state => state.auth);
///console.log(cpuData);
    let cpuNameToDisplay = cpuData.name;

    if (cpuNameToDisplay !== null) {
        // @ts-ignore
        cpuNameToDisplay = cpuNameToDisplay.replace(/\@.*/, '');
    }

    let playerNameToDisplay = user.name;

    playerNameToDisplay = playerNameToDisplay.replace(/\@.*/, '');

    const playerRankClass = user.rank.rank + 'Rank';

    const cpuRankClass = cpuData.rank + 'Rank';
    if (cpuData.rank && !cpuData.bl_count) {
        cpuData.bl_count = 0;
    }

    return (<div className={'game-header-container font-oswald-bold'}>
        <div className={'gh-player-container'}>
            <div className={'gh-playerName'}>{playerNameToDisplay}</div>
            <div className={'gh-playerBl'}>
                <div className={'gh-playerBlIco'}></div>
                <div className={'gh-playerBlValue'}>x{user.bl_count}</div>
            </div>
            <div className={'gh-playerRank ' + playerRankClass}></div>
        </div>

        <div className={'gh-cpu-container'}>
            {(cpuData.rank) ?
                <div className={'gh-playerRank ' + cpuRankClass}></div>
                : null
            }
            {(cpuData.bl_count !== null) ?
                <div className={'gh-playerBl'}>
                    <div className={'gh-playerBlIco'}></div>
                    <div className={'gh-playerBlValue'}>x{cpuData.bl_count}</div>
                </div>
                : null
            }
            <div className={'gh-cpuName'}>{cpuNameToDisplay}</div>
        </div>
    </div>)
}

export default Header;